import {PostInvoicePdfParams} from 'domain/usecases';
import {makePostInvoicePdf} from 'main/factories/usecases/private/my-payments-flow/remote-my-payments/post-invoice-pdf';

export async function postInvoicePdf(params: PostInvoicePdfParams) {
	const response = await makePostInvoicePdf().post({
		...params,
		signal: new AbortController().signal,
	});

	return response;
}
